export const formatLocalDateTime = (timestamp) => {
  if (!timestamp) return "-";

  let normalizedTimestamp = timestamp;
  if (
    typeof timestamp === "string" &&
    timestamp.includes("T") &&
    !timestamp.endsWith("Z") &&
    !/\+\d{2}:?\d{2}$/.test(timestamp) &&
    !/-\d{2}:?\d{2}$/.test(timestamp)
  ) {
    normalizedTimestamp = `${timestamp}Z`;
  }

  const date = new Date(normalizedTimestamp);

  if (Number.isNaN(date.getTime())) return "-";

  const formatted = new Intl.DateTimeFormat(undefined, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);

  // Convert to upper case and normalize different representations of am/pm like "a.m."/"p.m." or "am"/"pm"
  return formatted.replace(/([ap]\.?\s?m\.?)/i, (match) => {
    return match.toUpperCase().replace(/\./g, '').replace(/\s/g, '');
  });
};
